import { withZod } from '@remix-validated-form/with-zod';
import { WebRoutes } from '@theprintbar/shared';
import { z } from 'zod';
import { zfd } from 'zod-form-data';

const { CreateAccount } = WebRoutes;

export const CreateAccountSteps = Object.entries(CreateAccount).map(([title, href]) => ({ title, href }));

export const CreateAccountRoutes = [CreateAccount.Landing, CreateAccount.Verify];

export const CustomerDetailSchema = z
	.object({
		firstName: z.string().min(1, 'Required').max(50, 'Max length of 50'),
		lastName: z.string().min(1, 'Required').max(50, 'Max length of 50'),
		email: z.string().email('Please enter a valid email').max(254, 'Max length of 254'),
		password: z.string().min(8, 'Password must be at least 8 characters').max(50, 'Max length of 50'),
		confirmPassword: z.string().optional(), //Not actually optional but a trick to let us delete the key later, as our refine covers the "required" part
	})
	.refine(({ password, confirmPassword }) => password === confirmPassword, {
		message: 'Passwords do not match',
		path: ['confirmPassword'],
	});

export type CustomerDetailForm = z.infer<typeof CustomerDetailSchema>;
export const customerDetailsValidator = withZod(CustomerDetailSchema);

export const VerifySchema = z.object({
	otp: zfd.text(),
});

export type VerifyForm = z.infer<typeof VerifySchema>;
export const verifyValidator = withZod(VerifySchema);

export const createAccountSchema = z.object({
	[CreateAccount.Landing]: CustomerDetailSchema,
	[CreateAccount.Verify]: VerifySchema,
});

export const createAccountValidator = withZod(createAccountSchema);

export type CreateAccountForm = z.infer<typeof createAccountSchema>;
